export const DATE_FORMAT_YMD = 'YYYY-MM-DD';
export const DATE_FORMAT_SLASH_MDY = 'MM/DD/YYYY';
export const DATE_FORMAT_DASH_MMDDYYYY = 'MM-DD-YYYY';
export const DATE_FORMAT_SLASH_MDYYYY = 'M/D/YYYY';
export const DATE_FORMAT_DASH_MDYYYY = 'M-D-YYYY';
export const DATE_FORMAT_SLASH_MDDYYYY = 'M/DD/YYYY';
export const DATE_FORMAT_DASH_MDDYYYY = 'M-DD-YYYY';
export const DATE_FORMAT_SLASH_MD = 'MM/DD';
export const DATE_FORMAT_DOT_MDY = 'MM.DD.YYYY';
export const DATEPICKER_FORMAT_DOT_MDY = 'MM.dd.yyyy';
export const DATE_FORMAT_YEAR_MONTH_NUMERIC = 'YYYY-MM';
export const DATE_FORMAT_FULL_MONTH_YEAR = 'MMMM-YYYY';
export const DATE_FORMAT_FULL_YEAR = 'YYYY';
export const DATE_FORMAT_ISO_8601 = 'YYYY-MM-DD HH:mm:ss';
export const TIME_FORMAT_HH_MM_SS = 'HH:mm:ss';
export const DATE_TIME_FORMAT_WITH_AM_PM = 'MM/DD/YYYY hh:mm A';
export const DATE_TIME_FORMAT_DOT_MDY_WITH_AM_PM = 'MM.DD.YYYY hh:mm A';
export const DATE_TIME_FORMAT_LONG = 'MMM DD, YYYY hh:mm:ss A';
export const TIME_FORMAT_WITH_AM_PM = 'h A';
export const TIME_FORMAT_HMS = 'h:mm:ss';
export const DATE_FORMAT_DD_MM_YYYY = 'DD/MM/YYYY';
